import { Component } from '@angular/core';

@Component({
  selector: 'app-save-user-dialog',
  templateUrl: './save-user-dialog.component.html',
  styleUrls: ['./save-user-dialog.component.scss']
})
export class SaveUserDialogComponent {

}
